import { BaseModel } from "../../../ensue-react-system/utilities/base-model";
import { IFootballTeamCoach } from "./interface/i-football-team-coach";

export class FootballTeamCoach extends BaseModel implements IFootballTeamCoach {
  public id: number = 0;
  public firstName: string = "";
  public middleName?: string | undefined = "";
  public lastName: string = "";
  public fullName: string = "";
  public email: string = "";
  public avatar: string = "";

  public constructor(props: { [key: string]: any } | undefined = undefined) {
    super(props);
    this.__init(props);
  }
}
